import React, { useEffect, useState } from "react";
import { Formik, FieldArray, Field } from "formik";
import Swal from "sweetalert2";
import * as globalSettingsService from "../../../services/globalsetting.services";
import Breadcrums from "../../../common/breadcrumbs";
import {
  blockInvalidChar,
  handleServerValidations,
} from "../../../../../utils/commonfunction";
import { SWAL_SETTINGS } from "../../../../../utils/Constants";
import Loader from "../../../common/loader";
import {
  URL_REGEX,
  amountRegex,
  MOBILE_NUMBER_REGEX,
} from "../../../../../utils/Constants";
import { useTranslation } from "react-i18next";
import { Tooltip, Whisper } from "rsuite";

const GlobalSettings = (props) => {
  const { t } = useTranslation();
  const [showdefault, setShowDefault] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [submitClicked, setSubmitClicked] = useState(false);
  const [previewimage, setPreviewImage] = useState("");
  const [previewTopIcon, setPreviewTopIcon] = useState("");
  const [previewNewIcon, setPreviewNewIcon] = useState("");
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("sidebar_link_global_settings"), url: "" },
  ];

  useEffect(() => {
    globalSettingsService
      .Details()
      .then((response) => {
        setShowDefault(response && response.data ? response?.data : []);
        setPreviewImage(response?.data?.website_logo);
        setPreviewTopIcon(response?.data?.top_icon);
        setPreviewNewIcon(response?.data?.new_icon);
        setTimeout(() => {
          setDataLoaded(true);
        }, 100);
      })
      .catch((error) => {
        console.log("error=====>", error);
        setDataLoaded(true);
      });
  }, []);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {dataLoaded ? (
        <Formik
          validateOnChange={true}
          enableReinitialize
          initialValues={{
            Address:
              showdefault && showdefault.address ? showdefault.address : "",
            AdminEmail:
              showdefault && showdefault.admin_email
                ? showdefault.admin_email
                : "",
            contactEmail:
              showdefault && showdefault.contact_email
                ? showdefault.contact_email
                : "",
            financeEmail:
              showdefault && showdefault.finance_email
                ? showdefault.finance_email
                : "",
            Contact:
              showdefault && showdefault.phone_number
                ? showdefault.phone_number
                : "",
            admin_commission_percent:
              showdefault && showdefault.admin_commission_percent
                ? showdefault.admin_commission_percent
                : "",
            admin_reward_set:
              showdefault && showdefault.admin_reward_set
                ? showdefault.admin_reward_set
                : "",
            refer_reward_points:
              showdefault && showdefault.refer_reward_points !== null
                ? showdefault.refer_reward_points
                : "",
            reward_point_value_inr:
              showdefault && showdefault.reward_point_value_inr !== null
                ? showdefault.reward_point_value_inr
                : "",
            reward_point_value_usd:
              showdefault && showdefault.reward_point_value_usd !== null
                ? showdefault.reward_point_value_usd
                : "",
            client_markup_percent:
              showdefault && showdefault.client_markup_percent
                ? showdefault.client_markup_percent
                : "",
            usd_to_inr_rate:
              showdefault && showdefault.usd_to_inr_rate
                ? showdefault.usd_to_inr_rate
                : "",
            CopyRighttxt:
              showdefault && showdefault.copy_right_text
                ? showdefault.copy_right_text
                : "",

            web: showdefault && showdefault.website ? showdefault.website : "",
            title: showdefault && showdefault.title ? showdefault.title : "",
            website_info:
              showdefault && showdefault.website_info
                ? showdefault.website_info
                : "",
            website_logo:
              showdefault && showdefault.website_logo
                ? showdefault.website_logo
                : "",
            top_icon:
              showdefault && showdefault.top_icon
                ? showdefault.top_icon
                : "",
            new_icon:
              showdefault && showdefault.new_icon
                ? showdefault.new_icon
                : "",
            wallet_recharge_status:
              showdefault && showdefault.wallet_recharge_status
                ? showdefault.wallet_recharge_status
                : "false",
            socialMedia: (() => {
              let sm = showdefault?.social_media_details;
              if (typeof sm === "string") {
                try {
                  sm = JSON.parse(sm);
                } catch (e) {
                  sm = [];
                }
              }
              return Array.isArray(sm) && sm.length > 0
                ? sm
                : [{ title: "", link: "", icon: "" }];
            })(),

            global_discount_percentage:
              showdefault?.global_discount_percentage !== undefined
                ? showdefault.global_discount_percentage
                : "",


            global_free_consultation_minutes:
              showdefault?.global_free_consultation_minutes ?? "",

            ai_free_consultation_minutes:
              showdefault?.ai_free_consultation_minutes ?? "",

            ai_trial_subscription_free_minutes:
              showdefault?.ai_trial_subscription_free_minutes ?? "",

            context_ai_price_inr:
              showdefault?.context_ai_price_inr !== undefined &&
              showdefault?.context_ai_price_inr !== null
                ? showdefault.context_ai_price_inr
                : "",

            context_ai_price_usd:
              showdefault?.context_ai_price_usd !== undefined &&
              showdefault?.context_ai_price_usd !== null
                ? showdefault.context_ai_price_usd
                : "",

            free_delivery_min_amount:
              showdefault?.free_delivery_min_amount !== undefined &&
              showdefault?.free_delivery_min_amount !== null
                ? showdefault.free_delivery_min_amount
                : "",

            wallet_gst_percent:
              showdefault?.wallet_gst_percent !== undefined &&
              showdefault?.wallet_gst_percent !== null
                ? showdefault.wallet_gst_percent
                : (showdefault?.gst_percent ?? ""),

            consultation_gst_percent:
              showdefault?.consultation_gst_percent !== undefined &&
              showdefault?.consultation_gst_percent !== null
                ? showdefault.consultation_gst_percent
                : (showdefault?.gst_percent ?? ""),
          }}
          validate={(values) => {
            const trimmed = (val) =>
              typeof val === "string" ? val.trim() : val;
            let error = { socialMedia: [] };

            if (Array.isArray(values?.socialMedia) && values?.socialMedia?.length > 0) {
              values?.socialMedia.forEach((element, i) => {
                error.socialMedia[i] = {};
                if (!element.title) {
                  error.socialMedia[i]["title"] = t(
                    "validation_err_title_required",
                  );
                }
                if (element.title.length > 20) {
                  error.socialMedia[i]["title"] = t(
                    "validation_err_reached_maximum_length",
                  );
                }
                if (!element.icon) {
                  error.socialMedia[i]["icon"] = t(
                    "validation_err_icon_required",
                  );
                }
                if (element.icon.length > 50) {
                  error.socialMedia[i]["icon"] = t(
                    "validation_err_reached_maximum_length",
                  );
                }
                if (!element.link) {
                  error.socialMedia[i]["link"] = t(
                    "validation_err_link_required",
                  );
                }
                if (element.link.length > 50) {
                  error.socialMedia[i]["link"] = t(
                    "validation_err_reached_maximum_length",
                  );
                } else if (!URL_REGEX.test(element.link)) {
                  error.socialMedia[i]["link"] = t("invalid_web_url");
                }
              });
            }
            if (Array.isArray(error.socialMedia) && error.socialMedia.length) {
              let socialMediaFlag = 0;
              error.socialMedia.forEach((element, i) => {
                if (Object.keys(element).length) {
                  socialMediaFlag++;
                }
              });
              if (!socialMediaFlag) {
                delete error.socialMedia;
              }
            } else {
              delete error.socialMedia;
            }

            // Admin Email
            if (!trimmed(values.AdminEmail)) {
              error.AdminEmail = t("label_email_error");
            } else if (
              !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                trimmed(values.AdminEmail),
              )
            ) {
              error.AdminEmail = t("invalid_email");
            }

            // Contact Email
            if (!trimmed(values.contactEmail)) {
              error.contactEmail = t("label_email_error");
            } else if (
              !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                trimmed(values.contactEmail),
              )
            ) {
              error.contactEmail = t("invalid_email");
            }

            // Finance Email
            if (!trimmed(values.financeEmail)) {
              error.financeEmail = t("label_email_error");
            } else if (
              !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                trimmed(values.financeEmail),
              )
            ) {
              error.financeEmail = t("invalid_email");
            }

            // Contact Number
            const contactStr = String(values.Contact || "").trim();
            if (!contactStr) {
              error.Contact = t("label_phone_number_required_error");
            } else if (!MOBILE_NUMBER_REGEX.test(contactStr)) {
              error.Contact = t("label_contact_invalid_error");
            }

            const commissionStr = String(
              values.admin_commission_percent || "",
            ).trim();
            if (!commissionStr) {
              error.admin_commission_percent = t(
                "Platform commission is required",
              );
            } else if (
              !amountRegex.test(commissionStr) ||
              parseFloat(commissionStr) < 0 ||
              parseFloat(commissionStr) > 100
            ) {
              error.admin_commission_percent = t(
                "Platform commission must be a number between 0 and 100",
              );
            }

            const commissionRewardStr = String(
              values.admin_reward_set || "",
            ).trim();
            if (!commissionRewardStr) {
              error.admin_reward_set = t("Platform reward is required");
            } else if (
              !amountRegex.test(commissionRewardStr) ||
              parseFloat(commissionRewardStr) < 0 ||
              parseFloat(commissionRewardStr) > 100
            ) {
              error.admin_reward_set = t(
                "Admin reward points must be a positive number",
              );
            }

            const referRewardStr = String(
              values.refer_reward_points || "",
            ).trim();
            if (!referRewardStr) {
              error.refer_reward_points = t(
                "Refer reward points is required",
              );
            } else if (
              !amountRegex.test(referRewardStr) ||
              parseFloat(referRewardStr) < 0
            ) {
              error.refer_reward_points = t(
                "Refer reward points must be a positive number",
              );
            }

            const rewardInrStr = String(
              values.reward_point_value_inr || "",
            ).trim();
            if (!rewardInrStr) {
              error.reward_point_value_inr = t(
                "Reward point INR value is required",
              );
            } else if (
              parseFloat(rewardInrStr) < 0
            ) {
              error.reward_point_value_inr = t(
                "Reward point INR value must be positive",
              );
            }

            const rewardUsdStr = String(
              values.reward_point_value_usd || "",
            ).trim();
            if (!rewardUsdStr) {
              error.reward_point_value_usd = t(
                "Reward point USD value is required",
              );
            } else if (
              parseFloat(rewardUsdStr) < 0
            ) {
              error.reward_point_value_usd = t(
                "Reward point USD value must be positive",
              );
            }

            const commissionClientStr = String(
              values.client_markup_percent || "",
            ).trim();
            if (!commissionClientStr) {
              error.client_markup_percent = t("Client markup is required");
            } else if (
              !amountRegex.test(commissionClientStr) ||
              parseFloat(commissionClientStr) < 0 ||
              parseFloat(commissionClientStr) > 100
            ) {
              error.client_markup_percent = t(
                "Client markup must be a number between 0 and 100",
              );
            }

            /* const usdToInrRateStr = String(values.usd_to_inr_rate || "").trim();
            if (!usdToInrRateStr) {
              error.usd_to_inr_rate = t("USD to INR rate is required");
            } else if (!amountRegex.test(usdToInrRateStr) || parseFloat(usdToInrRateStr) <= 0) {
              error.usd_to_inr_rate = t("USD to INR rate must be a positive number");
            } */

            // Address
            const addressTrimmed = trimmed(values.Address);
            if (!addressTrimmed) {
              error.Address = t("label_location_error");
            } else if (addressTrimmed.length > 100) {
              error.Address = t("validation_err_reached_maximum_length"); // or custom: "Address must be max 100 characters"
            }

            // Website URL
            const webTrimmed = trimmed(values.web);
            if (!webTrimmed) {
              error.web = t("website_error");
            } else if (!URL_REGEX.test(webTrimmed)) {
              error.web = t("invalid_web_url");
            }

            // Copyright Text
            const copyrightTrimmed = trimmed(values.CopyRighttxt);
            if (!copyrightTrimmed) {
              error.CopyRighttxt = t("copyright_error");
            } else if (copyrightTrimmed.length > 200) {
              error.CopyRighttxt =
                "Copyright text must not exceed 200 characters";
            }

            // Website Title
            const titleTrimmed = trimmed(values.title);
            if (!titleTrimmed) {
              error.title = t("label_title_error");
            } else if (titleTrimmed.length > 50) {
              error.title = t("label_title_length_error_50");
            }

            // Website Info
            const infoTrimmed = trimmed(values.website_info);
            if (!infoTrimmed) {
              error.website_info = t("Website information is required");
            } else if (infoTrimmed.length > 150) {
              error.website_info = t("Exceed maximum length of 150");
            }
            if (
              !values.wallet_recharge_status ||
              values.wallet_recharge_status === "false" ||
              values.wallet_recharge_status === "true"
            ) {
              // Always valid since it's a select with only two options
            } else {
              error.wallet_recharge_status = "Please select a valid status";
            }

            //global_discount_percentage

            const globalDiscountStr = String(
              values.global_discount_percentage ?? "",
            ).trim();

            if (!globalDiscountStr) {
              error.global_discount_percentage = t(
                "Global discount is required",
              );
            } else if (
              !amountRegex.test(globalDiscountStr) ||
              parseFloat(globalDiscountStr) < 0 ||
              parseFloat(globalDiscountStr) > 100
            ) {
              error.global_discount_percentage = t(
                "Global discount must be between 0 and 100",
              );
            }

            //Global free consultation minutes validation
            const freeMinutes = Number(values.global_free_consultation_minutes);

            if (
              values.global_free_consultation_minutes === "" ||
              values.global_free_consultation_minutes === null
            ) {
              error.global_free_consultation_minutes = t(
                "Global free consultation minutes is required",
              );
            } else if (!Number.isInteger(freeMinutes)) {
              error.global_free_consultation_minutes = t(
                "Only whole numbers are allowed",
              );
            } else if (freeMinutes < 0 || freeMinutes > 1000) {
              error.global_free_consultation_minutes = t(
                "Global free consultation minutes must be between 0 and 1000",
              );
            }

            //AI free consultation minutes validation (Max 60 min)
            const aiFreeMinutes = Number(values.ai_free_consultation_minutes);

            if (
              values.ai_free_consultation_minutes === "" ||
              values.ai_free_consultation_minutes === null
            ) {
              error.ai_free_consultation_minutes = t(
                "AI free consultation minutes is required",
              );
            } else if (!Number.isInteger(aiFreeMinutes)) {
              error.ai_free_consultation_minutes = t(
                "Only whole numbers are allowed",
              );
            } else if (aiFreeMinutes < 0 || aiFreeMinutes > 60) {
              error.ai_free_consultation_minutes = t(
                "AI free consultation minutes must be between 0 and 60",
              );
            }

            //AI trial subscription free consultation minutes validation
            const aiSubFreeMinutes = Number(values.ai_trial_subscription_free_minutes);

            if (
              values.ai_trial_subscription_free_minutes === "" ||
              values.ai_trial_subscription_free_minutes === null
            ) {
              error.ai_trial_subscription_free_minutes = t(
                "AI trial subscription free consultation minutes is required",
              );
            } else if (!Number.isInteger(aiSubFreeMinutes)) {
              error.ai_trial_subscription_free_minutes = t(
                "Only whole numbers are allowed",
              );
            } else if (aiSubFreeMinutes < 0 || aiSubFreeMinutes > 1000) {
              error.ai_trial_subscription_free_minutes = t(
                "AI trial subscription free consultation minutes must be between 0 and 1000",
              );
            }

            const contextAiPriceInrStr = String(
              values.context_ai_price_inr ?? "",
            ).trim();

            if (
              values.context_ai_price_inr === "" ||
              values.context_ai_price_inr === null
            ) {
              error.context_ai_price_inr = t(
                "Context AI Price (In INR) is required",
              );
            } else if (
              !amountRegex.test(contextAiPriceInrStr) ||
              parseFloat(contextAiPriceInrStr) < 0
            ) {
              error.context_ai_price_inr = t(
                "Context AI Price (In INR) must be a positive number",
              );
            }

            const contextAiPriceUsdStr = String(
              values.context_ai_price_usd ?? "",
            ).trim();

            if (
              values.context_ai_price_usd === "" ||
              values.context_ai_price_usd === null
            ) {
              error.context_ai_price_usd = t(
                "Context AI Price (In USD) is required",
              );
            } else if (
              !amountRegex.test(contextAiPriceUsdStr) ||
              parseFloat(contextAiPriceUsdStr) < 0
            ) {
              error.context_ai_price_usd = t(
                "Context AI Price (In USD) must be a positive number",
              );
            }

            // Validate website logo image
            if (values.website_logo) {
              const image = values.website_logo;
              if (typeof image === "string") {
                // Check if it's a URL (either HTTP or HTTPS)
                const urlRegex = /^(http|https):\/\/[^\s$.?#].[^\s]*$/gm;
                if (!urlRegex.test(image)) {
                  error.website_logo = t("invalid_image_url");
                }
              } else {
                // Check file type (JPG, JPEG, PNG, WEBP, GIF)
                const validFileTypes = [
                  "image/jpg",
                  "image/jpeg",
                  "image/png",
                  "image/webp",
                  "image/gif",
                ];
                if (!validFileTypes.includes(image.type)) {
                  error.website_logo = t("supported_file_error");
                }

                // Check file size (max 1.5MB)
                if (image.size > 5 * 1024 * 1024) {
                  error.website_logo = t("image_max_size_error");
                }
              }
            } else {
              error.website_logo = t("image_required_error");
            }

            return error;
          }}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            setSubmitted(true);
            let formData = new FormData();
            formData.append("address", values.Address);
            formData.append("website", values.web);
            formData.append("admin_email", values.AdminEmail);
            formData.append("contact_email", values.contactEmail);
            formData.append("finance_email", values.financeEmail);
            formData.append(
              "social_media_details",
              JSON.stringify(values.socialMedia),
            );
            formData.append("phone_number", values.Contact);
            formData.append("copy_right_text", values.CopyRighttxt);
            formData.append("title", values.title);
            formData.append("website_info", values.website_info);
            if (
              values.website_logo &&
              typeof values.website_logo !== "string"
            ) {
              formData.append("website_logo", values.website_logo);
            }
            if (
              values.top_icon &&
              typeof values.top_icon !== "string"
            ) {
              formData.append("top_icon", values.top_icon);
            }
            if (
              values.new_icon &&
              typeof values.new_icon !== "string"
            ) {
              formData.append("new_icon", values.new_icon);
            }
            formData.append(
              "wallet_recharge_status",
              values.wallet_recharge_status,
            );
            formData.append(
              "admin_commission_percent",
              values.admin_commission_percent,
            );
            formData.append("admin_reward_set", values.admin_reward_set);
            formData.append(
              "refer_reward_points",
              values.refer_reward_points,
            );
            formData.append(
              "reward_point_value_inr",
              values.reward_point_value_inr,
            );
            formData.append(
              "reward_point_value_usd",
              values.reward_point_value_usd,
            );
            formData.append(
              "client_markup_percent",
              values.client_markup_percent,
            );
            formData.append("usd_to_inr_rate", values.usd_to_inr_rate);
            formData.append(
              "global_discount_percentage",
              values.global_discount_percentage,
            );
            formData.append(
              "global_free_consultation_minutes",
              values.global_free_consultation_minutes,
            );
            formData.append(
              "ai_free_consultation_minutes",
              values.ai_free_consultation_minutes,
            );
            formData.append(
              "ai_trial_subscription_free_minutes",
              values.ai_trial_subscription_free_minutes,
            );
            formData.append(
              "context_ai_price_inr",
              values.context_ai_price_inr,
            );
            formData.append(
              "context_ai_price_usd",
              values.context_ai_price_usd,
            );
            formData.append(
              "free_delivery_min_amount",
              values.free_delivery_min_amount,
            );
            formData.append(
              "wallet_gst_percent",
              values.wallet_gst_percent,
            );
            formData.append(
              "consultation_gst_percent",
              values.consultation_gst_percent,
            );
            formData.append(
              "gst_percent",
              values.wallet_gst_percent,
            );
            globalSettingsService
              .Add(formData)
              .then((response) => {
                if (response.success) {
                  Swal.fire({
                    icon: "success",
                    text: response.message,
                    ...SWAL_SETTINGS,
                  });
                  setTimeout(() => {
                    setSubmitted(false);
                  }, 2000);
                } else {
                  Swal.fire({
                    icon: "error",
                    text: handleServerValidations(response),
                    ...SWAL_SETTINGS,
                  });
                  setSubmitted(false);
                }
              })
              .catch((error) => {
                console.log("error ====> ", error);
              });
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            isSubmitting,
            setFieldTouched,
          }) => (
            <form onSubmit={handleSubmit}>
              {console.log("values", values)}
              {console.log("error", errors)}
              <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                  <div className="card custom-card">
                    <div className="card-body">
                      <div>
                        <h6 className="main-content-label mb-3">
                          {t("sidebar_link_global_settings")}
                        </h6>
                      </div>
                      <div className="row row-sm">
                        {/* <div className="col-md-12 text-center form-group">
                          <label
                            htmlFor="smtp_username"
                            className="text-left d-flex"
                          >
                            SMTP {t("label_username")}:<span className="requirestar">*</span>
                          </label>
                          <input
                            name="smtp_username"
                            type="text"
                            id="smtp_username"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.smtp_username}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.smtp_username &&
                              touched.smtp_username &&
                              errors.smtp_username}
                          </span>
                        </div> */}
                        <div className="col-md-12 text-center form-group">
                          <label
                            htmlFor="AdminEmail"
                            className="text-left d-flex"
                          >
                            {t("role_super_admin")} {t("label_email")}:
                            <span className="requirestar">*</span>
                          </label>
                          <input
                            name="AdminEmail"
                            type="text"
                            id="AdminEmail"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.AdminEmail}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.AdminEmail &&
                              touched.AdminEmail &&
                              errors.AdminEmail}
                          </span>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label
                            htmlFor="contactEmail"
                            className="text-left d-flex"
                          >
                            {t("Contact Email")}:
                            <span className="requirestar">*</span>
                          </label>
                          <input
                            name="contactEmail"
                            type="text"
                            id="contactEmail"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.contactEmail}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.contactEmail &&
                              touched.contactEmail &&
                              errors.contactEmail}
                          </span>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label
                            htmlFor="financeEmail"
                            className="text-left d-flex"
                          >
                            {t("Finance Email")}:
                            <span className="requirestar">*</span>
                          </label>
                          <input
                            name="financeEmail"
                            type="text"
                            id="financeEmail"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.financeEmail}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.financeEmail &&
                              touched.financeEmail &&
                              errors.financeEmail}
                          </span>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label htmlFor="Contact" className="text-left d-flex">
                            {t("label_contact_no")}:
                            <span className="requirestar">*</span>
                          </label>
                          <input
                            name="Contact"
                            type="text"
                            id="Contact"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.Contact}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.Contact &&
                              touched.Contact &&
                              errors.Contact}
                          </span>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label htmlFor="Address" className="text-left d-flex">
                            {t("list_heading_address")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <textarea
                            name="Address"
                            id="Address"
                            type="text"
                            style={{ minHeight: "100px" }}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.Address}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.Address &&
                              touched.Address &&
                              errors.Address}
                          </span>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label htmlFor="web" className="text-left d-flex">
                            {t("label_website")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <input
                            name="web"
                            id="web"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.web}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.web && touched.web && errors.web}
                          </span>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label
                            htmlFor="CopyRighttxt"
                            className="text-left d-flex"
                          >
                            {t("label_copy_right_text")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <input
                            name="CopyRighttxt"
                            type="text"
                            id="CopyRighttxt"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.CopyRighttxt}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.CopyRighttxt &&
                              touched.CopyRighttxt &&
                              errors.CopyRighttxt}
                          </span>
                        </div>
                        <div className="col-md-12 text-center form-group">
                          <label
                            htmlFor="admin_commission_percent"
                            className="text-left d-flex"
                          >
                            {t("Admin commission percent")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <input
                            name="admin_commission_percent"
                            type="number"
                            id="admin_commission_percent"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.admin_commission_percent}
                            className="form-control"
                            placeholder="Admin commission percent"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.admin_commission_percent &&
                              touched.admin_commission_percent &&
                              errors.admin_commission_percent}
                          </span>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label
                            htmlFor="admin_reward_set"
                            className="text-left d-flex"
                          >
                            {t("Admin Reward Points")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <input
                            name="admin_reward_set"
                            type="number"
                            id="admin_reward_set"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.admin_reward_set}
                            className="form-control"
                            placeholder="Admin reward points"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.admin_reward_set &&
                              touched.admin_reward_set &&
                              errors.admin_reward_set}
                          </span>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label
                            htmlFor="refer_reward_points"
                            className="text-left d-flex"
                          >
                            {t("Refer Reward Points")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <input
                            name="refer_reward_points"
                            type="number"
                            id="refer_reward_points"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.refer_reward_points}
                            className="form-control"
                            placeholder="Refer reward points"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.refer_reward_points &&
                              touched.refer_reward_points &&
                              errors.refer_reward_points}
                          </span>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label
                            htmlFor="reward_point_value_inr"
                            className="text-left d-flex"
                          >
                            {t("1 Point Value (in Paise) for Refer & Reward")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <input
                            name="reward_point_value_inr"
                            type="number"
                            step="1"
                            id="reward_point_value_inr"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.reward_point_value_inr}
                            className="form-control"
                            placeholder="Value in Paise (e.g. 10 for 10 Paise)"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.reward_point_value_inr &&
                              touched.reward_point_value_inr &&
                              errors.reward_point_value_inr}
                          </span>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label
                            htmlFor="reward_point_value_usd"
                            className="text-left d-flex"
                          >
                            {t("1 Point Value (in Cents) for Refer & Reward")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <input
                            name="reward_point_value_usd"
                            type="number"
                            step="1"
                            id="reward_point_value_usd"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.reward_point_value_usd}
                            className="form-control"
                            placeholder="Value in Cents (e.g. 5 for 5 Cents)"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.reward_point_value_usd &&
                              touched.reward_point_value_usd &&
                              errors.reward_point_value_usd}
                          </span>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label
                            htmlFor="global_discount_percentage"
                            className="text-left d-flex"
                          >
                            Global Discount (%):
                            <span className="requirestar">*</span>
                          </label>

                          <input
                            name="global_discount_percentage"
                            type="number"
                            id="global_discount_percentage"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.global_discount_percentage}
                            className="form-control"
                            placeholder="Global Discount %"
                            min="0"
                            max="100"
                          />

                          <span className="text-danger d-flex text-left">
                            {errors.global_discount_percentage &&
                              touched.global_discount_percentage &&
                              errors.global_discount_percentage}
                          </span>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label
                            htmlFor="free_delivery_min_amount"
                            className="text-left d-flex"
                          >
                            {t("Free Delivery Minimum Order Amount (India - ₹)")}:
                          </label>

                          <input
                            name="free_delivery_min_amount"
                            type="number"
                            id="free_delivery_min_amount"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.free_delivery_min_amount}
                            className="form-control"
                            placeholder="Free delivery minimum amount in ₹ (India only)"
                            min="0"
                          />

                          <span className="text-danger d-flex text-left">
                            {errors.free_delivery_min_amount &&
                              touched.free_delivery_min_amount &&
                              errors.free_delivery_min_amount}
                          </span>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label
                            htmlFor="wallet_gst_percent"
                            className="text-left d-flex"
                          >
                            {t("GST (%) (Wallet Recharge - India Only)")}:
                          </label>

                          <input
                            name="wallet_gst_percent"
                            type="number"
                            id="wallet_gst_percent"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.wallet_gst_percent}
                            className="form-control"
                            placeholder="Enter Wallet GST % (e.g. 18)"
                            min="0"
                            max="100"
                            step="0.01"
                          />

                          <span className="text-danger d-flex text-left">
                            {errors.wallet_gst_percent &&
                              touched.wallet_gst_percent &&
                              errors.wallet_gst_percent}
                          </span>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label
                            htmlFor="consultation_gst_percent"
                            className="text-left d-flex"
                          >
                            {t("GST (%) (Consultation - India Only)")}:
                          </label>

                          <input
                            name="consultation_gst_percent"
                            type="number"
                            id="consultation_gst_percent"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.consultation_gst_percent}
                            className="form-control"
                            placeholder="Enter Consultation GST % (e.g. 18)"
                            min="0"
                            max="100"
                            step="0.01"
                          />

                          <span className="text-danger d-flex text-left">
                            {errors.consultation_gst_percent &&
                              touched.consultation_gst_percent &&
                              errors.consultation_gst_percent}
                          </span>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label
                            htmlFor="global_free_consultation_minutes"
                            className="text-left d-flex"
                          >
                            Global Free Consultation Minutes:
                            <span className="requirestar">*</span>
                          </label>

                          <input
                            name="global_free_consultation_minutes"
                            type="number"
                            id="global_free_consultation_minutes"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values?.global_free_consultation_minutes}
                            className="form-control"
                            placeholder="Global Free Consultation Minutes"
                            min="0"
                            step="1"
                            onKeyDown={blockInvalidChar} // agar ye e,+,-,. block karta hai
                          />

                          <span className="text-danger d-flex text-left">
                            {errors.global_free_consultation_minutes &&
                              touched.global_free_consultation_minutes &&
                              errors.global_free_consultation_minutes}
                          </span>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label
                            htmlFor="ai_free_consultation_minutes"
                            className="text-left d-flex"
                          >
                            AI Astrologer Free Consultation Minutes:
                            <span className="requirestar">*</span>
                          </label>

                          <input
                            name="ai_free_consultation_minutes"
                            type="number"
                            id="ai_free_consultation_minutes"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values?.ai_free_consultation_minutes}
                            className="form-control"
                            placeholder="AI Astrologer Free Consultation Minutes (Max 60)"
                            min="0"
                            max="60"
                            step="1"
                            onKeyDown={blockInvalidChar}
                          />

                          <span className="text-danger d-flex text-left">
                            {errors.ai_free_consultation_minutes &&
                              touched.ai_free_consultation_minutes &&
                              errors.ai_free_consultation_minutes}
                          </span>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label
                            htmlFor="ai_trial_subscription_free_minutes"
                            className="text-left d-flex"
                          >
                            AI Astrologer Trial Subscription Free Minutes:
                            <span className="requirestar">*</span>
                          </label>

                          <input
                            name="ai_trial_subscription_free_minutes"
                            type="number"
                            id="ai_trial_subscription_free_minutes"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values?.ai_trial_subscription_free_minutes}
                            className="form-control"
                            placeholder="AI Astrologer Trial Subscription Free Minutes"
                            min="0"
                            step="1"
                            onKeyDown={blockInvalidChar}
                          />

                          <span className="text-danger d-flex text-left">
                            {errors.ai_trial_subscription_free_minutes &&
                              touched.ai_trial_subscription_free_minutes &&
                              errors.ai_trial_subscription_free_minutes}
                          </span>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label
                            htmlFor="context_ai_price_inr"
                            className="text-left d-flex"
                          >
                            Context AI Price (In INR):
                            <span className="requirestar">*</span>
                          </label>

                          <input
                            name="context_ai_price_inr"
                            type="number"
                            step="any"
                            id="context_ai_price_inr"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values?.context_ai_price_inr}
                            className="form-control"
                            placeholder="Context AI Price (In INR)"
                            min="0"
                          />

                          <span className="text-danger d-flex text-left">
                            {errors.context_ai_price_inr &&
                              touched.context_ai_price_inr &&
                              errors.context_ai_price_inr}
                          </span>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label
                            htmlFor="context_ai_price_usd"
                            className="text-left d-flex"
                          >
                            Context AI Price (In USD):
                            <span className="requirestar">*</span>
                          </label>

                          <input
                            name="context_ai_price_usd"
                            type="number"
                            step="any"
                            id="context_ai_price_usd"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values?.context_ai_price_usd}
                            className="form-control"
                            placeholder="Context AI Price (In USD)"
                            min="0"
                          />

                          <span className="text-danger d-flex text-left">
                            {errors.context_ai_price_usd &&
                              touched.context_ai_price_usd &&
                              errors.context_ai_price_usd}
                          </span>
                        </div>

                        <div className="col-lg-6 text-center form-group">
                          <label htmlFor="top_icon" className="text-left d-flex">
                            Top Icon:
                          </label>
                          <input
                            className="form-control imgInput"
                            id="top_icon"
                            name="top_icon"
                            accept="image/*"
                            type="file"
                            onChange={(event) => {
                              const file = event.target.files[0] || "";
                              setFieldValue("top_icon", file);
                              file
                                ? setPreviewTopIcon(URL.createObjectURL(file))
                                : setPreviewTopIcon("");
                            }}
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.top_icon &&
                              touched.top_icon &&
                              errors.top_icon}
                          </span>
                          {previewTopIcon ? (
                            <ul className="question-image-preview questions-ul mt-2">
                              <li className="pr_img_box">
                                <img
                                  src={previewTopIcon}
                                  style={{ height: "100px" }}
                                  alt={"Top Icon Preview"}
                                />
                              </li>
                            </ul>
                          ) : (
                            ""
                          )}
                        </div>

                        <div className="col-lg-6 text-center form-group">
                          <label htmlFor="new_icon" className="text-left d-flex">
                            New Icon:
                          </label>
                          <input
                            className="form-control imgInput"
                            id="new_icon"
                            name="new_icon"
                            accept="image/*"
                            type="file"
                            onChange={(event) => {
                              const file = event.target.files[0] || "";
                              setFieldValue("new_icon", file);
                              file
                                ? setPreviewNewIcon(URL.createObjectURL(file))
                                : setPreviewNewIcon("");
                            }}
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.new_icon &&
                              touched.new_icon &&
                              errors.new_icon}
                          </span>
                          {previewNewIcon ? (
                            <ul className="question-image-preview questions-ul mt-2">
                              <li className="pr_img_box">
                                <img
                                  src={previewNewIcon}
                                  style={{ height: "100px" }}
                                  alt={"New Icon Preview"}
                                />
                              </li>
                            </ul>
                          ) : (
                            ""
                          )}
                        </div>

                        {/* <div className="col-md-12 text-center form-group">
                          <label
                            htmlFor="client_markup_percent"
                            className="text-left d-flex"
                          >
                            {t("Client markup percent")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <input
                            name="client_markup_percent"
                            type="number"
                            id="client_markup_percent"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.client_markup_percent}
                            className="form-control"
                            placeholder="Client markup percent"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.client_markup_percent &&
                              touched.client_markup_percent &&
                              errors.client_markup_percent}
                          </span>
                        </div> */}

                        {/* <div className="col-md-12 text-center form-group">
                          <label
                            htmlFor="usd_to_inr_rate"
                            className="text-left d-flex"
                          >
                            {t("USD to INR Rate")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <input
                            name="usd_to_inr_rate"
                            type="number"
                            step="0.01"
                            id="usd_to_inr_rate"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.usd_to_inr_rate}
                            className="form-control"
                            placeholder="USD to INR rate"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.usd_to_inr_rate &&
                              touched.usd_to_inr_rate &&
                              errors.usd_to_inr_rate}
                          </span>
                        </div> */}
                        {/* 
                        <div className="col-md-12 text-center form-group">
                          <label
                            htmlFor="title"
                            className="text-left d-flex"
                          >
                            {t("Website title")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <input
                            name="title"
                            type="text"
                            id="title"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.title}
                            className="form-control"
                            placeholder="Website title"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.title &&
                              touched.title &&
                              errors.title}
                          </span>
                        </div> */}

                        {/* <div className="col-md-12 text-center form-group">
                          <label
                            htmlFor="website_info"
                            className="text-left d-flex"
                          >
                            {t("Website Info")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <input
                            name="website_info"
                            type="text"
                            id="website_info"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.website_info}
                            className="form-control"
                            placeholder="Website info"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.website_info &&
                              touched.website_info &&
                              errors.website_info}
                          </span>
                        </div> */}

                        {/* <div className="col-lg-6 text-center form-group">
                          <label htmlFor="website_logo" className="text-left d-flex">
                            {t("Website Logo")}:
                            {" "}
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>
                                  {t("image_support_tooltip")}
                                </Tooltip>
                              }
                            >
                              <span className="field-more-info mt-1 ms-1 cp">
                                ?
                              </span>
                            </Whisper>
                          </label>
                          <input
                            className="form-control imgInput"
                            id="website_logo"
                            name="website_logo"
                            accept="image/*"
                            type="file"
                            onChange={(event) => {
                              setFieldValue(
                                "website_logo",
                                event.target.files[0] || ""
                              );
                              event.target.files.length === 1
                                ? setPreviewImage(
                                  URL.createObjectURL(event.target.files[0])
                                )
                                : setPreviewImage("");
                            }}
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.website_logo &&
                              touched.website_logo &&
                              errors.website_logo}
                          </span>
                          {previewimage ? (
                            <ul className="question-image-preview questions-ul">
                              <li className="pr_img_box">
                                <img
                                  src={previewimage}
                                  style={{ height: "100px" }}
                                  alt={"profileImg"}
                                />
                              </li>
                            </ul>
                          ) : (
                            ""
                          )}
                        </div>

                         {/* <div className="col-md-6 text-center form-group">
                          <label
                            htmlFor="platform_commission"
                            className="text-left d-flex"
                          >
                            Platform Commission (%):
                            <span className="requirestar">*</span>{" "}
                          </label>

                          <div className="input-group mb-3">
                            
                            <input
                              name="platform_commission"
                              type="number"
                              id="platform_commission"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.platform_commission}
                              className="form-control"
                              onKeyDown={blockInvalidChar}
                            />
                            <div className="input-group-prepend">
                              <span className="input-group-text">%</span>
                            </div>
                          </div>
                          <span className="text-danger d-flex text-left">
                            {errors.platform_commission &&
                              touched.platform_commission &&
                              errors.platform_commission}
                          </span>
                        </div> */}

                        {/* <div className="col-md-6 text-center form-group">
                          <label htmlFor="wallet_recharge_status" className="text-left d-flex">
                            {t("Wallet recharge status")}:
                            <span className="requirestar">*</span>
                          </label>
                          <div className="select-down-arrow">
                            <select
                              name="wallet_recharge_status"
                              id="wallet_recharge_status"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={String(values.wallet_recharge_status)}
                              className="form-control"
                            >
                              <option value="false">{t("False")}</option>
                              <option value="true">{t("True")}</option>
                            </select>
                          </div>
                          <span className="text-danger d-flex text-left">
                            {errors.wallet_recharge_status &&
                              touched.wallet_recharge_status &&
                              errors.wallet_recharge_status}
                          </span>
                        </div> */}

                        {/*<div className="col-md-12 text-center form-group">
                          <label
                            htmlFor="yearly_restaurant_enrollment_cost"
                            className="text-left d-flex"
                          >
                            {t("yearly_enrollement_cost")}:
                            <span className="requirestar">*</span>{" "}
                          </label>

                          <div className="input-group mb-3">
                            <div className="input-group-prepend">
                              <span className="input-group-text">¥</span>
                            </div>
                            <input
                              name="yearly_restaurant_enrollment_cost"
                              type="text"
                              id="yearly_restaurant_enrollment_cost"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.yearly_restaurant_enrollment_cost}
                              className="form-control"
                            />
                          </div>
                          <span className="text-danger d-flex text-left">
                            {errors.yearly_restaurant_enrollment_cost &&
                              touched.yearly_restaurant_enrollment_cost &&
                              errors.yearly_restaurant_enrollment_cost}
                          </span>
                        </div> */}

                        {/* ---- */}

                        <label className="text-left d-flex">
                          {t("label_social_media")}:
                        </label>
                        <FieldArray
                          name="socialMedia"
                          render={(arrayHelper) => (
                            <div className="col-12 mb-4">
                              <div className="row">
                                {Array.isArray(values?.socialMedia) &&
                                values?.socialMedia?.length >= 0 ? (
                                  values?.socialMedia.map((item, index) => (
                                    <div className="col-12 " key={index}>
                                      <div className="w-100 p-2 bg-group">
                                        <div className="row">
                                          <div className="col-md-3 text-center form-group mb-0">
                                            <Field
                                              className="form-control"
                                              id="title"
                                              name={`socialMedia[${index}].title`}
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              value={item.title}
                                              placeholder={t(
                                                "input_placeholder_title",
                                              )}
                                            />
                                            <span className="text-danger d-flex text-left">
                                              {((touched?.socialMedia &&
                                                touched?.socialMedia[index] &&
                                                touched?.socialMedia[index]
                                                  .title) ||
                                                submitClicked) &&
                                                errors.socialMedia &&
                                                errors.socialMedia[index] &&
                                                errors.socialMedia[index].title}
                                            </span>
                                          </div>
                                          <div className="col-md-4 text-center form-group mb-0">
                                            <Field
                                              className="form-control"
                                              id="link"
                                              name={`socialMedia[${index}].link`}
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              value={item.link}
                                              placeholder={t(
                                                "input_placeholder_link",
                                              )}
                                            />
                                            <span className="text-danger d-flex text-left">
                                              {((touched.socialMedia &&
                                                touched.socialMedia[index] &&
                                                touched.socialMedia[index]
                                                  .link) ||
                                                submitClicked) &&
                                                errors.socialMedia &&
                                                errors.socialMedia[index] &&
                                                errors.socialMedia[index].link}
                                            </span>
                                          </div>
                                          <div className="col-md-3 text-center form-group mb-0">
                                            <Field
                                              className="form-control"
                                              id="icon"
                                              name={`socialMedia[${index}].icon`}
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              value={item.icon}
                                              placeholder={t(
                                                "input_placeholder_icon",
                                              )}
                                            />
                                            <span className="text-danger d-flex text-left">
                                              {((touched.socialMedia &&
                                                touched.socialMedia[index] &&
                                                touched.socialMedia[index]
                                                  .icon) ||
                                                submitClicked) &&
                                                errors.socialMedia &&
                                                errors.socialMedia[index] &&
                                                errors.socialMedia[index].icon}
                                            </span>
                                          </div>
                                          <div className="col-md-2">
                                            <div className="social-media-action">
                                              <button
                                                className="btn btn-danger "
                                                type="button"
                                                disabled={
                                                  values?.socialMedia
                                                    ?.length === 1
                                                }
                                                onClick={() =>
                                                  arrayHelper.remove(index)
                                                } // remove a friend from the list
                                              >
                                                {t("link_remove")}
                                              </button>
                                              {index ===
                                                values?.socialMedia?.length -
                                                  1 && (
                                                <button
                                                  className="btn btn-main-primary signbtn ms-2 "
                                                  type="button"
                                                  onClick={() =>
                                                    arrayHelper.insert(
                                                      values?.socialMedia
                                                        ?.length,
                                                      {
                                                        title: "",
                                                        link: "",
                                                        icon: "",
                                                      },
                                                    )
                                                  }
                                                >
                                                  {t("link_add")}
                                                </button>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <button
                                    className="btn btn-main-primary signbtn mr-2 ms-2 mb-3"
                                    type="button"
                                    onClick={() => arrayHelper.push({})}
                                  >
                                    Add a social media
                                  </button>
                                )}
                              </div>
                            </div>
                          )}
                        />

                        <div className="">
                          <button
                            className="btn btn-main-primary signbtn mr-2"
                            type="submit"
                            disabled={submitted ? true : null}
                            onClick={() => {
                              setSubmitClicked(true);
                            }}
                          >
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("btn_submit")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default GlobalSettings;
